export const colors = {
  lightBlue: "#508aff",
  darkBlue: "#1563ff",
};
